/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_DISPLAY_COOLER_SUMMARY_STATS = gql`
  query GetDisplayCoolerSummaryStats(
    $displayId: ID!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    displayCoolerSummaryStats(
      displayId: $displayId
      startDate: $startDate
      endDate: $endDate
    ) {
      displayId
      complianceScore
      lastSnapshotDate
      revenue
      revenueTrend
    }
  }
`
